import { Button } from "@arco-design/web-react";
import { ChevronDown, SlidersHorizontal } from "lucide-react";

import "./AdvancedFilterToggle.css";

export type AdvancedFilterToggleProps = {
  expanded: boolean;
  onToggle: () => void;
  label?: string;
  className?: string;
};

/**
 * 复用型高级筛选折叠按钮。
 *
 * 统一提供单行胶囊样式、展开状态箭头反馈与无障碍文案，
 * 供列表页或查询页直接接入。
 */
export function AdvancedFilterToggle({
  expanded,
  onToggle,
  label = "高级筛选",
  className,
}: AdvancedFilterToggleProps) {
  const rootClassName = ["advanced-filter-toggle", expanded ? "is-expanded" : "", className ?? ""]
    .filter(Boolean)
    .join(" ");

  return (
    <Button
      type="text"
      className={rootClassName}
      aria-label={expanded ? `收起${label}` : `展开${label}`}
      aria-expanded={expanded}
      onClick={onToggle}
    >
      <span className="advanced-filter-toggle__icon" aria-hidden="true">
        <SlidersHorizontal size={15} strokeWidth={2.2} />
      </span>
      <span className="advanced-filter-toggle__label">{label}</span>
      <span className="advanced-filter-toggle__caret" aria-hidden="true">
        <ChevronDown size={16} strokeWidth={2.25} />
      </span>
    </Button>
  );
}
